class ProductsSlider extends HTMLElement {
    constructor() {
        super();
        this.slideContainer();
    }

    slideContainer() {
        document.addEventListener("DOMContentLoaded", () => {
            const sliderElement = this.querySelector('.product-slider__mobile');
            const swiper = new Swiper(sliderElement, {
                loop: true,
                slidesPerView: 4.3,
                spaceBetween: 32,
                autoplay: {
                    delay: 5000,
                },
                touchRatio: 0.2,
                breakpoints: {
                    300: {
                        slidesPerView: 1.7,
                        spaceBetween: 16,
                    },
                    600: {
                        slidesPerView: 3,
                        spaceBetween: 16,
                    },
                    1024: {
                        slidesPerView: 4,
                        spaceBetween: 16,
                    },
                    1441: {
                        slidesPerView: 5,
                        spaceBetween: 16,
                    },
                    1800: {
                        slidesPerView: 6,
                        spaceBetween: 16,
                    },
                    2200: {
                        slidesPerView: 7,
                        spaceBetween: 16,
                    },
                },
            });

            const buttons = sliderElement.querySelectorAll('.products-slider__item__info-buy-button');
            buttons.forEach((button) => {
                button.addEventListener('touchstart', (e) => {
                    swiper.allowTouchMove = false;
                });
                button.addEventListener('touchend', (e) => {
                    swiper.allowTouchMove = true;
                });
            });
        });
    }
}

customElements.define('products-slider', ProductsSlider);
